import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
window.Vue.component('vue-ctk-date-timepicker', VueCtkDateTimePicker);
window.Vue.component("v-chart-bar", require("./componentes/ChartBar.vue").default);
window.Vue.component("v-select-check", require("./componentes/SelectCheck.vue").default);

require("./secciones/reportes/pagos")
require("./secciones/catalogo/productos")
require("./secciones/ventas/cupones")
require("./secciones/ventas/pedidos")
require("./secciones/clientes/clientes")
require("./secciones/clientes/clientes-suscripciones")
